import { render, staticRenderFns } from "./TextEllipsis.vue?vue&type=template&id=3ba1b72f&scoped=true"
import script from "./TextEllipsis.vue?vue&type=script&lang=js"
export * from "./TextEllipsis.vue?vue&type=script&lang=js"
import style0 from "./TextEllipsis.vue?vue&type=style&index=0&id=3ba1b72f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba1b72f",
  null
  
)

export default component.exports